<h1 mat-dialog-title>Alerta Sonoro</h1>
<div class="content" mat-dialog-content>
  Deseja habilitar o alerta sonoro ?
</div>
<div class="buttons" mat-dialog-actions>
  <button mat-raised-button (click)="onNoClick()"><div>Cancelar</div></button>
  <button class="confirm-button" mat-raised-button (click)="onOkClick()" ><div>Sim</div></button>
</div>
